export const SIGN_IN = 'sign_in';
export const SIGN_OUT = 'sign_out';
export const GET_ACCOUNTS = 'get_accounts';
export const GET_ACCOUNTS_COUNT = 'get_accounts_count';
export const DELETE_AACOUNT = 'delete_account';
export const GET_FACTURAS = 'get_facturas';
export const GET_FACTURAS_COUNT = 'get_facturas_count';
